import React from "react";
import { Input, Form } from "antd";


const FormFields = () => {

  return (
    <>
      <Form.Item
        name="name"
        label="Nom de la specialité"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom de la specialité",
          },
        ]}
      >
        <Input placeholder="Nom" />
      </Form.Item>
      <Form.Item
        name="abreviation"
        label="abreviation"
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer l'abreviation",
          },
        ]}
      >
        <Input placeholder="abreviation" />
      </Form.Item>
    </>
  );
};

export default FormFields;
